import { useEffect, useState } from "react";

const API=`${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSacralGuide=(isPremium)=>{
  const[premiumContent,setPremiumContent]=useState(null);
  useEffect(()=>{if(!isPremium){setPremiumContent(null);return undefined}const controller=new AbortController();fetch(`${API}/member/sacral-guide`,{credentials:"include",signal:controller.signal}).then((response)=>response.ok?response.json():Promise.reject()).then(setPremiumContent).catch((error)=>{if(error.name!=="AbortError")setPremiumContent(null)});return()=>controller.abort()},[isPremium]);
  return premiumContent;
};